import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';

import { RowActionsMenuProps } from './RowActionsMenu.props';

export const RowActionsMenu: React.FC<RowActionsMenuProps> = ({
  onAction,
  nodeId,
  actions,
  itemLabel = 'node',
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  if (actions.length === 0) return null;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action: string) => {
    handleClose();
    onAction(action);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        aria-label={`Actions for ${itemLabel} ${nodeId}`}
        sx={{ color: 'v4.accent' }}
      >
        <MoreVertIcon sx={{ fontSize: 18 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        slotProps={{
          paper: {
            sx: {
              boxShadow: '0 4px 12px rgba(0,0,0,.1)',
              borderRadius: 1.5,
              minWidth: 160,
            },
          },
        }}
      >
        {actions.map((item) => (
          <MenuItem
            key={item.key}
            onClick={() => handleAction(item.key)}
            sx={{ fontSize: '13px', py: 0.75 }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
